
export function titlefySignInUrl(): string {
    const pathName = '/auth/sign-in/fin';    
    const titlefyURL = `https://pro.flueid.com${pathName}`;

    return titlefyURL;
}